export const MONITOR_STATUS_DRAWER_QUERY_NAMESPACE = ["monitor-status-drawer"];
